import { useState } from 'react';
import { UMIcon, UMInput, UMR } from '../../urbanmap/_components';
import { PLAN } from '../proposition-c/tokens';
import type { TeamMember } from './types';
import { Avatar } from './ui';

export function StepTeam({
  candidates, members, onChange,
}: {
  candidates: TeamMember[];
  members: TeamMember[];
  onChange: (members: TeamMember[]) => void;
}) {
  const [search, setSearch] = useState('');
  const invitedIds = new Set(members.map((m) => m.id));
  const matches = candidates.filter(
    (c) => !invitedIds.has(c.id) && (c.name.toLowerCase().includes(search.toLowerCase()) || c.job.toLowerCase().includes(search.toLowerCase())),
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'flex', gap: 12, padding: 12, background: UMR.messageInfoBg, border: `1px solid ${UMR.messageInfoBorder}`, fontSize: 14 }}>
        <UMIcon name="group" size={20} color={UMR.blueLink} />
        <div>
          Seules les personnes ayant <strong>déjà accès à UrbanMap</strong> peuvent être invitées.
          Les membres invités travaillent sur le projet en lecture et en écriture.
        </div>
      </div>

      <div>
        <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 8 }}>Équipe du projet · {members.length}</div>
        <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 6 }}>
          {members.map((m) => (
            <li key={m.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 8px', border: `1px solid ${UMR.borderSubtle}` }}>
              <Avatar member={m} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 600 }}>{m.name}</div>
                <div style={{ fontSize: 12, color: UMR.textSecondary }}>{m.job}</div>
              </div>
              {m.owner ? (
                <span style={{ fontSize: 12, padding: '2px 8px', background: PLAN.accentBg, color: PLAN.accentStrong, border: `1px solid ${PLAN.accentBorder}` }}>
                  Propriétaire
                </span>
              ) : (
                <button
                  type="button"
                  aria-label={`Retirer ${m.name}`}
                  onClick={() => onChange(members.filter((x) => x.id !== m.id))}
                  style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 4 }}
                >
                  <UMIcon name="close" family="icons" size={18} color={UMR.textSecondary} />
                </button>
              )}
            </li>
          ))}
        </ul>
      </div>

      <div>
        <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 8 }}>Inviter depuis les utilisateurs UrbanMap</div>
        <UMInput value={search} onChange={setSearch} ariaLabel="Rechercher un utilisateur UrbanMap" placeholder="Nom ou métier…" icon="search" />
        <ul style={{ listStyle: 'none', margin: '8px 0 0', padding: 0, display: 'flex', flexDirection: 'column', gap: 4, maxHeight: 180, overflowY: 'auto' }}>
          {matches.length === 0 && (
            <li style={{ fontSize: 13, color: UMR.textSecondary, padding: '8px 0' }}>
              Aucun utilisateur UrbanMap ne correspond à cette recherche.
            </li>
          )}
          {matches.map((c) => (
            <li key={c.id}>
              <button
                type="button"
                onClick={() => onChange([...members, { ...c, owner: false }])}
                style={{
                  width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '6px 8px', cursor: 'pointer',
                  border: `1px solid ${UMR.borderSubtle}`, background: UMR.white, fontFamily: UMR.font, textAlign: 'left',
                }}
              >
                <Avatar member={c} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14 }}>{c.name}</div>
                  <div style={{ fontSize: 12, color: UMR.textSecondary }}>{c.job}</div>
                </div>
                <UMIcon name="person_add" size={18} color={UMR.blue} />
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
